import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';

export default function ServiceDetailPage() {
  const { slug } = useParams();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useState(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  const servicesData: Record<string, any> = {
    construction: {
      title: 'الإنشاءات',
      description: 'نقدم خدمات الإنشاءات والبناء بأعلى معايير الجودة والاحترافية، حيث نعمل على تنفيذ المشاريع الإنشائية من البداية حتى التسليم النهائي. فريقنا المتخصص يضمن تنفيذ المشاريع وفقاً للمواصفات والمعايير العالمية.',
      image: 'https://public.readdy.ai/ai/img_res/acfdc21e65d4558696023cdaee5366ed.jpg',
      features: [
        'تشييد المباني السكنية والتجارية',
        'البناء بأحدث التقنيات والمواد',
        'إدارة المشاريع الإنشائية الكبرى',
        'الالتزام بالمواعيد والميزانية',
        'ضمان الجودة والسلامة',
        'استخدام مواد بناء عالية الجودة'
      ],
      content: 'تتميز شركة الهمة الذهبية بخبرة واسعة في مجال الإنشاءات والبناء، حيث نقدم حلولاً متكاملة تشمل جميع مراحل البناء من التخطيط والتصميم إلى التنفيذ والتسليم. نستخدم أحدث التقنيات والمعدات لضمان تنفيذ المشاريع بأعلى معايير الجودة والسلامة. فريقنا من المهندسين والفنيين المتخصصين يعمل بكفاءة عالية لتحقيق رؤية العملاء وتجاوز توقعاتهم.'
    },
    renovation: {
      title: 'الترميم',
      description: 'نوفر خدمات ترميم شاملة للمباني والمنشآت بأحدث التقنيات، حيث نعمل على إعادة الحياة للمباني القديمة وتحديثها لتلبية المعايير الحديثة. نضمن الحفاظ على الهيكل الأصلي مع تحسين الأداء والمظهر.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20building%20renovation%20and%20restoration%20project%2C%20skilled%20workers%20repairing%20and%20upgrading%20commercial%20facility%20interior%20and%20exterior%2C%20modern%20renovation%20techniques%20with%20quality%20materials%20and%20equipment%2C%20corporate%20construction%20photography%20with%20before%20and%20after%20concept&width=1200&height=800&seq=service-detail-renovation-002&orientation=landscape',
      features: [
        'ترميم المباني السكنية والتجارية',
        'إصلاح الشروخ والتصدعات',
        'تحديث الواجهات والديكورات',
        'إعادة تأهيل المنشآت القديمة',
        'الحفاظ على الطابع المعماري',
        'استخدام مواد ترميم متطورة'
      ],
      content: 'خدمات الترميم التي نقدمها تشمل جميع أنواع أعمال الإصلاح والتجديد للمباني والمنشآت. نستخدم أحدث التقنيات في الكشف عن المشاكل الإنشائية ومعالجتها بطرق علمية مدروسة. فريقنا المتخصص يعمل على إعادة تأهيل المباني القديمة وتحديثها لتصبح أكثر كفاءة وجمالاً، مع الحفاظ على قيمتها التاريخية والمعمارية.'
    },
    piping: {
      title: 'تمديدات الأنابيب',
      description: 'نقدم خدمات تمديد الأنابيب بمختلف أنواعها بدقة واحترافية عالية، شاملة أنابيب المياه والصرف الصحي والغاز. نضمن تنفيذ التمديدات وفقاً للمواصفات الفنية والمعايير الدولية.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20plumbing%20and%20pipe%20installation%20work%20in%20commercial%20building%2C%20industrial%20piping%20systems%20with%20various%20types%20of%20pipes%20including%20water%20drainage%20and%20gas%20lines%2C%20skilled%20technicians%20installing%20modern%20piping%20infrastructure%2C%20corporate%20construction%20photography%20with%20technical%20details&width=1200&height=800&seq=service-detail-piping-003&orientation=landscape',
      features: [
        'تمديد أنابيب المياه',
        'تمديد أنابيب الصرف الصحي',
        'تمديد أنابيب الغاز',
        'تمديد الأنابيب الصناعية',
        'اختبار وفحص التمديدات',
        'صيانة شبكات الأنابيب'
      ],
      content: 'تتخصص شركة الهمة الذهبية في تمديد جميع أنواع الأنابيب بأعلى معايير الجودة والسلامة. نستخدم أحدث المعدات والتقنيات لضمان تنفيذ التمديدات بدقة عالية. فريقنا من الفنيين المتخصصين يعمل على تصميم وتنفيذ شبكات الأنابيب وفقاً للمواصفات الفنية المطلوبة، مع إجراء الاختبارات اللازمة لضمان كفاءة وسلامة التمديدات.'
    },
    electrical: {
      title: 'الأعمال الكهربائية',
      description: 'نوفر خدمات تمديد الأسلاك الكهربائية وأسلاك الاتصالات بأعلى معايير السلامة، شاملة جميع أنواع التركيبات الكهربائية من الإنارة إلى أنظمة الجهد المتوسط والمنخفض.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20electrical%20installation%20work%20in%20commercial%20building%2C%20electricians%20installing%20wiring%20and%20communication%20cables%20with%20safety%20equipment%2C%20modern%20electrical%20systems%20including%20lighting%20and%20power%20distribution%2C%20corporate%20construction%20photography%20with%20technical%20precision&width=1200&height=800&seq=service-detail-electrical-004&orientation=landscape',
      features: [
        'تمديد الأسلاك الكهربائية',
        'تمديد أسلاك الاتصالات',
        'تركيب أنظمة الإنارة',
        'أعمال الجهد المتوسط',
        'أعمال الجهد المنخفض',
        'صيانة الأنظمة الكهربائية'
      ],
      content: 'نقدم حلولاً كهربائية متكاملة تشمل جميع أنواع التركيبات والتمديدات الكهربائية. فريقنا من الكهربائيين المعتمدين يعمل وفقاً لأعلى معايير السلامة والجودة. نستخدم مواد ومعدات كهربائية عالية الجودة لضمان كفاءة وأمان الأنظمة الكهربائية. كما نقدم خدمات الصيانة الدورية والطارئة لضمان استمرارية عمل الأنظمة الكهربائية.'
    },
    mechanical: {
      title: 'الخدمات الميكانيكية',
      description: 'نقدم خدمات تركيب وصيانة الأعمال الميكانيكية والتكييف والتهوية والسباكة، شاملة جميع أنواع الأنظمة الميكانيكية من التكييف المركزي إلى أنظمة المضخات.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20HVAC%20and%20mechanical%20systems%20installation%20in%20commercial%20facility%2C%20technicians%20working%20on%20air%20conditioning%20ventilation%20and%20plumbing%20equipment%2C%20modern%20mechanical%20services%20including%20pumps%20and%20cooling%20systems%2C%20corporate%20construction%20photography%20with%20technical%20details&width=1200&height=800&seq=service-detail-mechanical-005&orientation=landscape',
      features: [
        'أعمال التكييف المركزي',
        'أنظمة التهوية',
        'تركيب المضخات',
        'أعمال السباكة',
        'صيانة الأنظمة الميكانيكية',
        'إدارة الطاقة والكفاءة'
      ],
      content: 'تتميز شركة الهمة الذهبية بخبرة واسعة في مجال الخدمات الميكانيكية، حيث نقدم حلولاً متكاملة تشمل تصميم وتركيب وصيانة جميع أنواع الأنظمة الميكانيكية. فريقنا من المهندسين والفنيين المتخصصين يعمل على تنفيذ المشاريع بأعلى معايير الجودة والكفاءة. نستخدم أحدث التقنيات والمعدات لضمان أداء مثالي للأنظمة الميكانيكية.'
    },
    civil: {
      title: 'الأعمال المدنية',
      description: 'نوفر خدمات الأعمال المدنية الشاملة من تركيب الأبواب والشبابيك إلى الديكورات والمظلات والدهان والتبليط، مع الاهتمام بأدق التفاصيل لضمان نتائج مثالية.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20civil%20construction%20work%20including%20doors%20windows%20painting%20and%20tiling%20installation%2C%20skilled%20workers%20doing%20interior%20and%20exterior%20finishing%20work%20in%20commercial%20building%2C%20modern%20civil%20construction%20services%20with%20quality%20materials%2C%20corporate%20construction%20photography%20with%20detailed%20craftsmanship&width=1200&height=800&seq=service-detail-civil-006&orientation=landscape',
      features: [
        'تركيب الأبواب والشبابيك',
        'أعمال الديكورات الداخلية',
        'تركيب المظلات',
        'أعمال الدهان',
        'أعمال التبليط',
        'التشطيبات النهائية'
      ],
      content: 'نقدم خدمات الأعمال المدنية بأعلى مستويات الاحترافية والجودة. فريقنا من الحرفيين المهرة يعمل على تنفيذ جميع أنواع التشطيبات والديكورات بدقة واهتمام بالتفاصيل. نستخدم مواد عالية الجودة ونتبع أحدث الأساليب في التنفيذ لضمان نتائج تفوق التوقعات. سواء كانت أعمال الدهان أو التبليط أو تركيب الأبواب والشبابيك، نضمن تنفيذاً متقناً يعكس رؤيتنا في التميز.'
    },
    safety: {
      title: 'أنظمة السلامة',
      description: 'نتخصص في تركيب أنظمة الإطفاء والإنذار وحساسات الحريق والإطفاء بالغازات، مع توفير حلول سلامة متكاملة تضمن حماية الأرواح والممتلكات.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20fire%20safety%20systems%20installation%20in%20commercial%20building%2C%20fire%20suppression%20equipment%20with%20sprinklers%20alarms%20and%20gas%20suppression%20systems%2C%20modern%20fire%20protection%20infrastructure%20with%20safety%20equipment%2C%20corporate%20construction%20photography%20with%20safety%20focus%20and%20technical%20details&width=1200&height=800&seq=service-detail-safety-007&orientation=landscape',
      features: [
        'أنظمة الإطفاء التلقائي',
        'أنظمة الإنذار المبكر',
        'حساسات الحريق',
        'أنظمة الإطفاء بالغازات',
        'صيانة أنظمة السلامة',
        'التدريب على السلامة'
      ],
      content: 'تعتبر السلامة أولويتنا القصوى، ولذلك نقدم حلول سلامة متكاملة تشمل تصميم وتركيب وصيانة جميع أنواع أنظمة الحماية من الحرائق. فريقنا المتخصص يعمل وفقاً لأحدث المعايير الدولية في مجال السلامة. نستخدم أحدث التقنيات والمعدات لضمان فعالية الأنظمة في حالات الطوارئ. كما نقدم خدمات الفحص والصيانة الدورية لضمان جاهزية الأنظمة في جميع الأوقات.'
    },
    cleaning: {
      title: 'النظافة والمناظر الطبيعية',
      description: 'نقدم خدمات النظافة الشاملة للمرافق وتنسيق المناظر الطبيعية، مع الاهتمام بالتفاصيل لضمان بيئة نظيفة وجميلة.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20facility%20cleaning%20and%20landscaping%20services%20for%20commercial%20property%2C%20well-maintained%20gardens%20with%20beautiful%20plants%20and%20clean%20environment%2C%20modern%20landscape%20design%20with%20natural%20elements%20and%20professional%20maintenance%2C%20corporate%20photography%20with%20clean%20aesthetic&width=1200&height=800&seq=service-detail-cleaning-008&orientation=landscape',
      features: [
        'تنظيف المرافق التجارية',
        'تنظيف المباني السكنية',
        'تنسيق الحدائق',
        'صيانة المناظر الطبيعية',
        'خدمات النظافة الدورية',
        'إدارة النفايات'
      ],
      content: 'نوفر خدمات نظافة احترافية شاملة للمرافق المختلفة، بالإضافة إلى خدمات تنسيق وصيانة المناظر الطبيعية. فريقنا المدرب يستخدم أحدث المعدات والمواد الصديقة للبيئة لضمان نظافة مثالية. نقدم خطط صيانة دورية مخصصة تلبي احتياجات كل عميل. في مجال تنسيق الحدائق، نعمل على تصميم وتنفيذ مناظر طبيعية جميلة ومستدامة تعزز من جمال المكان.'
    },
    pumps: {
      title: 'تركيب المضخات',
      description: 'نتخصص في أعمال تركيب المضخات وتمديدها بأحدث التقنيات، شاملة جميع أنواع المضخات من مضخات المياه إلى مضخات الحريق.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20pump%20installation%20and%20piping%20work%20in%20industrial%20facility%2C%20modern%20water%20pumps%20and%20pumping%20systems%20with%20pipes%20and%20valves%2C%20skilled%20technicians%20installing%20and%20maintaining%20pump%20equipment%2C%20corporate%20construction%20photography%20with%20technical%20precision&width=1200&height=800&seq=service-detail-pumps-009&orientation=landscape',
      features: [
        'تركيب مضخات المياه',
        'تركيب مضخات الحريق',
        'تمديد شبكات المضخات',
        'صيانة المضخات',
        'اختبار وتشغيل المضخات',
        'إدارة أنظمة الضخ'
      ],
      content: 'نقدم خدمات متكاملة في مجال تركيب وصيانة المضخات بجميع أنواعها. فريقنا من الفنيين المتخصصين يعمل على تصميم وتنفيذ أنظمة الضخ وفقاً للمواصفات الفنية المطلوبة. نستخدم مضخات عالية الجودة من أفضل الشركات العالمية لضمان الأداء الأمثل والموثوقية. كما نقدم خدمات الصيانة الدورية والطارئة لضمان استمرارية عمل أنظمة الضخ بكفاءة عالية.'
    }
  };

  const service = servicesData[slug || ''] || servicesData.construction;

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#202835] shadow-lg' : 'bg-[#202835]'}`}>
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-between h-24">
            <Link className="flex items-center" to="/">
              <img 
                alt="شركة الهمة الذهبية" 
                className="h-16 w-auto" 
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/c39a188db929712e2f2919bb54dee404.png"
              />
            </Link>

            <nav className="hidden lg:flex items-center gap-8">
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/">
                الرئيسية
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/about">
                من نحن
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group text-[#d4af37]" to="/services">
                الخدمات
                <span className="absolute bottom-0 right-0 w-full h-0.5 bg-[#d4af37]"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/projects">
                المشاريع
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/news">
                الأخبار
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
            </nav>

            <Link className="hidden lg:block px-8 py-3 bg-[#d4af37] text-white font-bold rounded-full hover:bg-[#c19b2e] transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer" to="/contact">
              تواصل معنا
            </Link>

            <button 
              className="lg:hidden text-white text-2xl w-10 h-10 flex items-center justify-center cursor-pointer"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden bg-[#202835] border-t border-white/10">
            <nav className="container mx-auto px-6 py-4 flex flex-col gap-4">
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/">الرئيسية</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/about">من نحن</Link>
              <Link className="text-white font-semibold text-[#d4af37] transition-colors" to="/services">الخدمات</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/projects">المشاريع</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/news">الأخبار</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/contact">تواصل معنا</Link>
            </nav>
          </div>
        )}
      </header>

      {/* Hero Section */}
      <section className="relative h-[60vh] w-full overflow-hidden mt-24">
        <div className="absolute inset-0 w-full h-full">
          <img 
            alt={service.title} 
            className="w-full h-full object-cover object-center" 
            src={service.image}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#202835]/80 via-[#202835]/70 to-[#202835]/80"></div>
        </div>
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="container mx-auto px-6 text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">{service.title}</h1>
            <div className="w-20 h-1 bg-[#d4af37] mx-auto mb-6"></div>
            <p className="text-xl text-white/90 max-w-3xl mx-auto">
              {service.description}
            </p>
          </div>
        </div>
      </section>

      {/* Service Content */}
      <section className="py-32 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start mb-24">
            <div>
              <h2 className="text-4xl font-bold text-[#202835] mb-8">نبذة عن الخدمة</h2>
              <p className="text-lg text-[#202835]/80 leading-relaxed mb-8">
                {service.content}
              </p>
              <Link 
                to="/contact" 
                className="inline-block px-8 py-4 bg-[#d4af37] text-white font-bold rounded-full hover:bg-[#c19b2e] transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
              >
                اطلب الخدمة الآن
              </Link>
            </div>

            <div className="bg-[#faf8f3] rounded-2xl p-10">
              <h3 className="text-3xl font-bold text-[#202835] mb-8">مميزات الخدمة</h3>
              <ul className="space-y-4">
                {service.features.map((feature: string, index: number) => (
                  <li key={index} className="flex items-start gap-4">
                    <div className="w-6 h-6 bg-[#d4af37] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <span className="text-lg text-[#202835]/80">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative bg-[#202835] text-white overflow-hidden">
        <div className="container mx-auto px-6 relative z-10">
          <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            <div>
              <Link className="inline-block mb-6" to="/">
                <img 
                  alt="شركة الهمة الذهبية" 
                  className="h-16 w-auto" 
                  src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/c39a188db929712e2f2919bb54dee404.png"
                />
              </Link>
              <p className="text-white/80 leading-relaxed mb-6">
                شركة الهمة الذهبية، شريكك الموثوق في عالم المقاولات والإنشاءات.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">روابط سريعة</h3>
              <ul className="space-y-3">
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/about">من نحن</Link></li>
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/services">الخدمات</Link></li>
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/projects">المشاريع</Link></li>
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/news">الأخبار</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">خدماتنا</h3>
              <ul className="space-y-3">
                <li className="text-white/80">الإنشاءات والبناء</li>
                <li className="text-white/80">الترميم والصيانة</li>
                <li className="text-white/80">الأعمال الكهربائية</li>
                <li className="text-white/80">أنظمة السلامة</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">تواصل معنا</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3 text-white/80">
                  <i className="ri-phone-line text-[#d4af37] text-xl mt-1"></i>
                  <div>
                    <div dir="ltr">+966 50 016 5920</div>
                    <div dir="ltr">+966 50 125 5250</div>
                  </div>
                </li>
                <li className="flex items-start gap-3 text-white/80">
                  <i className="ri-mail-line text-[#d4af37] text-xl mt-1"></i>
                  <span>info@gmcc.com.sa</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 py-6">
            <p className="text-white/60 text-sm text-center">
              © 2024 شركة الهمة الذهبية. جميع الحقوق محفوظة.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
